var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStarIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 15,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.408.95c.186-.6.998-.6 1.184 0l1.226 3.948c.083.269.322.45.592.45h3.966c.603 0 .854.808.366 1.18l-3.208 2.44a.67.67 0 0 0-.227.728l1.226 3.948c.186.6-.47 1.1-.958.729l-3.209-2.44a.6.6 0 0 0-.732 0l-3.208 2.44c-.489.37-1.145-.129-.959-.73l1.226-3.947a.67.67 0 0 0-.227-.729L.258 6.527C-.23 6.158.02 5.349.624 5.349H4.59c.27 0 .509-.181.592-.45z"
})));
export default SvgStarIcon;